
import { categoryservice, tableservice } from "@/utils";
import { defineComponent } from "vue";

export default defineComponent({
  name: "editModal",
  props: {
    item: {
      type: Object,
    },
  },
  data: () => {
    return {
      categoryName: "" as any,
    };
  },
  setup(props) {
    console.log("dari edit modal", props.item);
  },
  mounted() {
    this.categoryName = this.item?.Name;
  },
  methods: {
    async update() {
      if (this.item?.type == "category") {
        const respons = await (
          await categoryservice.update({
            ...this.item,
            Name: this.categoryName,
          } as any)
        ).data;
      } else {
        const respons = await (
          await tableservice.update({
            ...this.item,
            Name: this.categoryName,
          } as any)
        ).data;
      }
      const id = Date.now();
      this.$notify({
        id,
        type: "success",
        duration: 3000,
        text: "succesfully deleted!",
      });
      this.$emit("submit");
      this.close();
      this.$router.push("/stores/" + this.item?.StoreId);
    },
    close() {
      this.$emit("close");
    },
  },
});
